(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();

  function initialize(hero) {
    if (initialized.has(hero)) return;
    initialized.add(hero);
    // Content is visible by default, including without JavaScript or Web Animations.
    if (reduced.matches || typeof hero.animate !== 'function') {
      hero.dataset.heroIntro = 'complete';
      return;
    }
    const panel = hero.querySelector('.hero-panel');
    const tag = hero.querySelector('.edition-tag');
    const office = hero.querySelector('.floating-card');
    if (!panel || !tag || !office) return;
    let started = false;
    let observer;

    function reveal() {
      if (started) return;
      started = true;
      observer?.disconnect();
      if (reduced.matches) {
        hero.dataset.heroIntro = 'complete';
        return;
      }
      const animations = [];
      const finish = () => animations.forEach(animation => {
        try { animation.finish(); } catch { animation.cancel(); }
      });
      const visibility = () => animations.forEach(animation => {
        if (animation.playState !== 'finished') {
          if (document.hidden) animation.pause();
          else animation.play();
        }
      });
      const preference = () => { if (reduced.matches) finish(); };
      const cleanup = () => {
        hero.dataset.heroIntro = 'complete';
        document.removeEventListener('visibilitychange', visibility);
        reduced.removeEventListener('change', preference);
        window.removeEventListener('pagehide', finish);
        window.removeEventListener('resize', finish);
      };
      hero.dataset.heroIntro = 'entering';
      try {
        // Limit the side travel to actual viewport space, including narrow phones.
        const left = Math.min(32, Math.max(0, tag.getBoundingClientRect().left - 2));
        const right = Math.min(36, Math.max(0, document.documentElement.clientWidth - office.getBoundingClientRect().right - 2));
        const motion = { duration: 1800, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'backwards' };
        const enter = (element, from, delay) => {
          animations.push(element.animate([
            { opacity: 0, transform: from },
            { opacity: 1, transform: 'none' }
          ], { ...motion, delay }));
        };
        // The panel contains both its surface/text frame and the upright Windows mark.
        enter(panel, 'translateY(22px)', 0);
        enter(tag, `translateX(${-left}px)`, 160);
        enter(office, `translateX(${right}px)`, 320);
        document.addEventListener('visibilitychange', visibility);
        reduced.addEventListener('change', preference);
        window.addEventListener('pagehide', finish);
        window.addEventListener('resize', finish);
        visibility();
        Promise.allSettled(animations.map(animation => animation.finished)).then(cleanup);
      } catch {
        animations.forEach(animation => animation.cancel());
        cleanup();
      }
    }

    const rect = hero.getBoundingClientRect();
    if (rect.bottom > 0 && rect.top < window.innerHeight && !document.hidden) reveal();
    else if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) reveal();
      }, { threshold: .12 });
      observer.observe(hero);
    } else reveal();
  }

  document.querySelectorAll('.hero-visual').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.hero-visual').forEach(initialize);
  });
})();
